import { __assign, __awaiter, __generator } from "tslib";
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, withCtx as _withCtx, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/banner.png';
import _imports_1 from '@/assets/right-icon.png';
import _imports_2 from '@/assets/home.png';
import _imports_3 from '@/assets/mine.png';
var _withScopeId = function (n) { return (_pushScopeId("data-v-5de39cce"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { class: "wrap" };
var _hoisted_2 = ["onClick"];
var _hoisted_3 = { class: "product-title" };
var _hoisted_4 = { class: "price" };
var _hoisted_5 = /*#__PURE__*/ _createTextVNode(" ¥");
var _hoisted_6 = { class: "describe" };
var _hoisted_7 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("div", { class: "right-box" }, [
    /*#__PURE__*/ _createElementVNode("img", {
        src: _imports_1,
        alt: ""
    })
], -1); });
var _hoisted_8 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("img", { src: _imports_2 }, null, -1); });
var _hoisted_9 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("img", { src: _imports_3 }, null, -1); });
import { reactive, ref } from "vue";
import { Toast } from "vant";
import { requestProductsList } from "@/api";
import { debounce } from "@/utils";
import router from "@/router";
import ReviewReport from "@/components/reviewReport.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'Products',
    setup: function (__props) {
        var _this = this;
        var loading = ref(false);
        var finished = ref(false);
        var pageParams = reactive({
            pageIndex: 0,
            pageSize: 10,
        });
        var productsList = ref([]);
        var getProductsList = function () { return __awaiter(_this, void 0, void 0, function () {
            var res, records;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        pageParams.pageIndex++;
                        return [4 /*yield*/, requestProductsList({
                                pageIndex: pageParams.pageIndex,
                                pageSize: pageParams.pageSize,
                            }).catch(function () {
                                Toast("系统错误-02");
                                finished.value = true;
                            })];
                    case 1:
                        res = _b.sent();
                        loading.value = false;
                        if (res.code === 200) {
                            if (pageParams.pageIndex === 1) {
                                productsList.value = [];
                            }
                            records = (_a = res.data.records) === null || _a === void 0 ? void 0 : _a.map(function (item) {
                                var _a;
                                return __assign(__assign({}, item), { skuPrice: (_a = item.skuPrice) === null || _a === void 0 ? void 0 : _a.toFixed(2) });
                            });
                            productsList.value = productsList.value.concat(records);
                            finished.value = res.data.pages <= pageParams.pageIndex;
                        }
                        else {
                            Toast(res.message);
                            productsList.value = [];
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        var debounceGetProductsList = debounce(getProductsList, 300);
        var onLoad = function () {
            loading.value = true;
            debounceGetProductsList();
        };
        var active = ref(0);
        var viewDetails = function (skuId, skuName, skuPrice) {
            router.push({
                path: "/product-details",
                query: {
                    skuId: skuId,
                    skuName: skuName,
                    skuPrice: skuPrice,
                },
            });
        };
        var reportVisible = ref(false);
        var goBannerPage = function () {
            location.href = "/banner.html";
        };
        return function (_ctx, _cache) {
            var _component_van_nav_bar = _resolveComponent("van-nav-bar");
            var _component_van_list = _resolveComponent("van-list");
            var _component_van_tabbar_item = _resolveComponent("van-tabbar-item");
            var _component_van_tabbar = _resolveComponent("van-tabbar");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_van_nav_bar, { title: "产品中心" }),
                _createElementVNode("div", { class: "banner" }, [
                    _createElementVNode("img", {
                        onClick: goBannerPage,
                        src: _imports_0,
                        alt: ""
                    })
                ]),
                _createVNode(_component_van_list, {
                    style: _normalizeStyle({ marginTop: '0.96rem' }),
                    loading: loading.value,
                    "onUpdate:loading": _cache[0] || (_cache[0] = function ($event) { return ((loading).value = $event); }),
                    finished: finished.value,
                    "finished-text": "没有更多了",
                    onLoad: onLoad
                }, {
                    default: _withCtx(function () { return [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(productsList.value, function (item) {
                            return (_openBlock(), _createElementBlock("div", {
                                class: "product-item",
                                key: item.skuId,
                                onClick: function ($event) { return (viewDetails(item.skuId, item.skuName, item.skuPrice)); }
                            }, [
                                _createElementVNode("div", {
                                    style: _normalizeStyle({ flex: 'auto', padding: '0.32rem' })
                                }, [
                                    _createElementVNode("p", _hoisted_3, _toDisplayString(item.skuName), 1),
                                    _createElementVNode("p", _hoisted_4, [
                                        _hoisted_5,
                                        _createElementVNode("span", {
                                            style: _normalizeStyle({ fontSize: '0.48rem' })
                                        }, _toDisplayString(item.skuPrice), 5)
                                    ]),
                                    _createElementVNode("p", _hoisted_6, _toDisplayString(item.skuDesc), 1)
                                ], 4),
                                _hoisted_7
                            ], 8, _hoisted_2));
                        }), 128))
                    ]; }),
                    _: 1
                }, 8, ["style", "loading", "finished"]),
                _createVNode(_component_van_tabbar, {
                    modelValue: active.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) { return ((active).value = $event); })
                }, {
                    default: _withCtx(function () { return [
                        _createVNode(_component_van_tabbar_item, null, {
                            icon: _withCtx(function () { return [
                                _hoisted_8
                            ]; }),
                            _: 1
                        }),
                        _createVNode(_component_van_tabbar_item, {
                            icon: "contact",
                            onClick: _cache[1] || (_cache[1] = function ($event) { return (_unref(router).push('/personal-center')); })
                        }, {
                            icon: _withCtx(function () { return [
                                _hoisted_9
                            ]; }),
                            _: 1
                        })
                    ]; }),
                    _: 1
                }, 8, ["modelValue"]),
                (reportVisible.value)
                    ? (_openBlock(), _createBlock(ReviewReport, {
                        key: 0,
                        title: "量觉科技",
                        reportUrl: "/DA-6P.pdf",
                        onCancel: _cache[3] || (_cache[3] = function () { return (reportVisible.value = false); })
                    }))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
